import React from 'react';

import Base from 'components/Svg/Base';

type Props = {
    className?: string;
    size?: number;
};

// eslint-disable-next-line import/prefer-default-export
export const OperationsIcon = ({ className, size }: Props) => (
    <Base className={className} size={size}>
        <path
            d="M13.89 2.88 9.2 2.14c-3.91-.61-5.72.71-6.34 4.62l-.74 4.69c-.4 2.56.02 4.22 1.47 5.23.76.54 1.8.9 3.15 1.11l4.69.74c3.91.61 5.72-.71 6.34-4.62l.73-4.69c.12-.77.17-1.46.13-2.07-.13-2.5-1.6-3.78-4.74-4.27ZM8.24 9.35c-1.17 0-2.12-.95-2.12-2.11 0-1.17.95-2.12 2.12-2.12 1.16 0 2.11.95 2.11 2.12 0 1.16-.95 2.11-2.11 2.11Z"
            fill="currentColor"
        />
        <path
            d="M20.5 13.47 19 17.98c-1.25 3.76-3.25 4.76-7.01 3.51l-4.51-1.5c-1.41-.47-2.43-1.05-3.09-1.78.63.25 1.36.44 2.19.57l4.7.74c.64.1 1.24.15 1.8.15 3.3 0 5.07-1.78 5.68-5.61l.73-4.69c.1-.58.14-1.09.14-1.56 1.52 1.25 1.74 3.03.87 5.66Z"
            fill="currentColor"
        />
    </Base>
);
